import { render } from "./jobsFeed.vue?vue&type=template&id=27e24fa1"
import script from "./jobsFeed.vue?vue&type=script&lang=js"
export * from "./jobsFeed.vue?vue&type=script&lang=js"

import "./jobsFeed.vue?vue&type=style&index=0&id=27e24fa1&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__